import { Button, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { DatePicker, } from 'antd';
const { RangePicker } = DatePicker;
import dayjs from 'dayjs';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { getAdjustedDate } from '../CommonFunctions';
import { calculateDateRangeFromDate } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
// import { getAdjustedDate } from '../../Common/CommonFunctions';
// import { calculateDateRangeFromDate } from '../../utils/DateConversion';
// import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
// import { APIConstants } from '../../Common/APIConstants';

 
export default function DailyConsumption(props) {
    // const data = props.data; 
    const theme = props.theme; 
    const [data, setData]= useState( 
      {
        groupName: 'Incomer',
        groupID: 1,
        groupPlusMeterConsumption: 0,
        groupMinusMeterConsumption: 0,
        groupConsumption: 0,
        cost: 0,
        finalCost: 0
      }    
    );
    const [data2,setData2]= useState([ { groupID: 1, groupName: 'Incomer', liveKwt: 0 } ])
    const {makeRequest} = useStoreUpdaterWithAPI();
         
    const correctDate =  new Date(getAdjustedDate());
  // console.log(correctDate)
    // Default start time: Today 6:30 AM, Default end time: Tomorrow 6:30 AM
  const defaultStartTime = dayjs(correctDate).hour(6).minute(30).second(0);
  const defaultEndTime = dayjs(correctDate).add(1, 'day').hour(6).minute(30).second(0);

  const [toDate, setToDate] = useState(defaultStartTime);
  const [fromDate, setFromDate] = useState(defaultEndTime);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value); 
  };
  

  const onRangeChange = (dates, dateStrings) => {
    // console.log(dateStrings)
    // console.log(dates)
    if (dates) {
      // console.log('From: ', dates[0], ', to: ', dates[1]);
      // console.log(new Date(dateStrings[0]).toLocaleString('en-GB', {
      //   weekday: 'short', 
      //   year: 'numeric', 
      //   month: 'short', 
      //   day: '2-digit', 
      //   hour: '2-digit', 
      //   minute: '2-digit', 
      //   second: '2-digit', 
      //   hour12: true
      // }).replace(',', ''))
      setToDate(new Date(dateStrings[0]).toLocaleString('en-GB', {
        weekday: 'short', 
        year: 'numeric', 
        month: 'short', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: true
      }).replace(',', ''))
      setFromDate(new Date(dateStrings[1]).toLocaleString('en-GB', {
        weekday: 'short', 
        year: 'numeric', 
        month: 'short', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: true
      }).replace(',', ''))
      console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    } else {
      console.log('Clear');
    }
  };
  
  const rangePresets = [
    {
      label: 'Last 7 Days',
      value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
      label: 'Last 14 Days',
      value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
      label: 'Last 30 Days',
      value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
      label: 'Last 90 Days',
      value: [dayjs().add(-90, 'd'), dayjs()],
    },
  ];

  
  const getReposnse1 =()=>{
    // setLoading(true)
    const currentDate = new Date(); 
  
    const { from, to } = calculateDateRangeFromDate(currentDate, 5,2);
  
    const inputData = {
      // ConverterID: Number(lgConvId),
      // MeterIds: ids,
      FromDate: from,  
      ToDate:to,
    }; 
    console.log('getReposnse')
    console.log(to, from)   
  
   
    try {      
      makeRequest({
        type: APIConstants.GET,     
    
        //http://20.244.40.160:83/Lucasdata?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00
        url:`${APIConstants.LUCAS_LIVE_DAILY_CONSUMPTION}?FromDate=${from}&ToDate=${to}`
        // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
        // token:token, 
        // body:chartInput      
      }).then((res) => {   
        console.log('response' )
        console.log(res)      
        // console.log(res[0]) 
        if(res&&res.length > 0 && res[0]){
          setData(res[0]) 
        }
        
  
      });
      // console.log('function  called')     
       
    } catch (error) {
      // setError(true);  
      console.log(error);
    }      
  
  }    
  const getReposnse2 =()=>{
    // setLoading(true)
    const currentDate = new Date(); 
  
    const { from, to } = calculateDateRangeFromDate(currentDate, 5,2);
  
    const inputData = {
      // ConverterID: Number(lgConvId),
      // MeterIds: ids,
      FromDate: from,  
      ToDate:to,
    }; 
    console.log('getReposnse')
    console.log(to, from)   
  
   
    try {      
      makeRequest({
        type: APIConstants.GET,     
    
        // GetLiveKwtvalue?FromDate=2024%2F10%2F01%2006%3A30%3A00&ToDate=2024%2F10%2F01%2006%3A30%3A00
        url:`${APIConstants.LUCAS_LIVE_KWT}?FromDate=${from}&ToDate=${to}`
        // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
        // token:token, 
        // body:chartInput      
      }).then((res) => {   
        console.log('response' )
        console.log(res)      
        // console.log(res[0]) 
        if(res&&res.length > 0 && res[0]){
          setData2(res[0]) 
        }
        
  
      });
      // console.log('function  called')     
        
    } catch (error) {
      // setError(true);  
      console.log(error);
    }      
  
  }    

  console.log(data)

  useEffect(() => {
    getReposnse1(); // Initial fetch
    getReposnse2(); // Initial fetch

    const intervalId = setInterval(() => {
      getReposnse1();
      getReposnse2();
    }, 60000); // 60000 milliseconds = 1 minute

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
        <div className='text-white  shadow-allsides flex-grow gap-3 flex flex-col flex-wrap hover:scale-105 hover:duration-500  w-full lg:w-[350px] pb-1'>
            <div className='flex gap-5 justify-between p-5 pb-0'>
                <span className={`${theme ==='light' ? "text-slate-600 ":"text-gray-50"}  text-2xl font-bold`}>Today Consumption</span>
            </div>
            <div className='p-2 m-0  w-full flex flex-col justify-center items-center'>
                <div className={`${theme ==='light' ? "text-slate-600 ":"text-gray-50"}  text-sm  underline font-bold `}>kWh Charge</div>
                <p className='text-xl text-gray-400 font-bold'>{data.finalCost}<span className='text-sm font-bold'> K </span></p>
                {/* <Input
                  placeholder="Type something..."
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{ marginBottom: '10px', width: '300px' }}
                /> */}
            </div>  
            <div className='flex md:flex-nowrap flex-wrap  justify-between gap-5  py-3 px-5'>
                <div className={`${theme ==='light' ? "bg-[#c8bfe7]  ":"bg-blue-950 "} p-2 flex-grow hover:scale-105 hover:duration-200 rounded-xl`}>
                    <p className={` ${theme ==='light' ? "bg-white text-gray-500":"bg-slate-950"} text-base m-0.5 py-3 px-4 rounded-md  text-center font-bold`}>Total Value</p>
                    <p className={`${theme ==='light' ? "text-slate-700 ":"text-gray-50"}  text-sm text-center m-0  p-4 font-bold `}>{data.groupPlusMeterConsumption + ' KWH'}</p>
                </div>
                <div className={` ${theme ==='light' ? "bg-[#c8bfe7] ":"bg-blue-950 "} p-2 flex-grow hover:scale-105 hover:duration-200 rounded-xl`}>
                    <p className={` ${theme ==='light' ? "bg-white text-gray-500":"bg-slate-950"} text-base m-0.5 py-3 px-4 rounded-md  text-center font-bold`}>Live Value</p>
                    {/* <p className='text-sm text-blue-500 m-0 p-4 text-center font-bold'>{data2.liveKwt + ' KWT'}</p> */}
                    <p className={`${theme ==='light' ? "text-slate-700 ":"text-gray-50"}  text-sm text-center m-0  p-4 font-bold `}>{data2.liveKwt + ' KWT'}</p>
                </div>
            </div>

            <div className="flex justify-center items-center w-[90%] m-auto">
    
                <p className='bg-transparent w-fit p-2 mb-2 text-white  bottom-0' >
              <RangePicker
                    presets={[
                      {
                        label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                        value: () => [dayjs(), dayjs().endOf('day')],
                      },
                      ...rangePresets,
                    ]}
                    showTime
                    format="YYYY/MM/DD HH:mm:ss"
                    defaultValue={[toDate, fromDate]}
                    className={`customRangePicker   ${theme === 'dark' ? 'customRangePicker-dark' : 'customRangePicker-light'}`}
                    onChange={onRangeChange}
                    open={false}
                    disabled={[true, true]}
                  />
                </p>   
      </div> 
      
      {/* <Modal
          centered 
          open={modalOpen}
          onCancel={handleCancel}
          className="custom-modal w-fit" 
          footer={null} 
          closable={false} 
        >
          <div className={` ${theme === 'dark'? "custom-date bg-slate-950":''} p-0 rounded-xl  shadow-allsides  overflow-hidden overflow-x-auto w-fit`}>


<RangePicker
      presets={[
        {
          label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
          value: () => [dayjs(), dayjs().endOf('day')],
        },
        ...rangePresets,
      ]}
      showTime
      format="YYYY/MM/DD HH:mm:ss"
      onChange={onRangeChange}
    />
  
            <div className="modal-footer w-full justify-end flex mt-4 gap-3">
              <Button onClick={handleCancel}>Close</Button>
              <Button type="primary" onClick={handleOk}>Search</Button>
            </div>
  
          </div>
        </Modal> */}
        </div>
    )
}